import AreaEmptyData from 'comps/AreaEmptyData';
import { FullProductCardItem } from '../components';

export default function SearchListContent({ shopList }) {
  return (
    <>
      {shopList ? (
        <div className="goods-grid">
          {shopList.map((item, index) => (
            <FullProductCardItem data={item} key={index} />
          ))}
        </div>
      ) : (
        <AreaEmptyData areaLevel={3} height="400px" />
      )}
      <style jsx>{`
        .goods-grid {
          margin-right: -20px;
          line-height: 1.4166666666666667;
        }
        .goods-grid:after {
          clear: both;
          display: block;
          content: "";
        }
        .pagination-wrap {
          text-align: right;
          margin-bottom: 40px;
        }
      `}</style>
    </>
  );
}
